import type { CustomerAccess } from '@atlassian/jira-servicedesk-customer-permissions/src/common/types.tsx';
import type { AppState } from '../../../model/app-state/types.tsx';
import type { State } from '../../../model/types.tsx';

export const getChannelsInfoState = (state: State): AppState => state.appState;

export const isWidgetEnabled = (state: State): boolean => getChannelsInfoState(state).widgetEnabled;

export const getCustomerAccess = (state: State): CustomerAccess => state.appState.customerAccess;

export const getServiceDeskEmail = (state: State): string =>
	getChannelsInfoState(state).serviceDeskEmail;

export const isLoading = (state: State): boolean => getChannelsInfoState(state).isLoading;

export const isEmailEnabled = (state: State): boolean =>
	!!getServiceDeskEmail(state) && getServiceDeskEmail(state).length > 0;

export const getPortalId = (state: State): number => getChannelsInfoState(state).portalId;

export const isChatEnabled = (state: State): boolean => getChannelsInfoState(state).chatEnabled;

export const getPortalUrl = (state: State): string => getChannelsInfoState(state).portalUrl;
